






















import { Vue, Component } from 'vue-property-decorator';
import FindJobsIcon from '@/components/SvgIcons/FindJobs.vue';
import MyJobsIcon from '@/components/SvgIcons/MyJobs.vue';
import ReferAFriendIcon from '@/components/SvgIcons/ReferAFriend.vue';
import JobAlertIcon from '@/components/SvgIcons/JobAlert.vue';
import ForumIcon from '@/components/SvgIcons/Forum.vue';
import MyReferralsIcon from '@/components/SvgIcons/MyReferrals.vue';
import HelpIcon from '@/components/SvgIcons/Help.vue';
import SurveyIcon from '@/components/SvgIcons/Survey.vue';
import TimesheetIcon from '@/components/SvgIcons/Timesheet.vue';
import InboxIcon from '@/components/SvgIcons/Inbox.vue';
import { vxm } from '@/store.vuex';
declare var window: any;
@Component({
  components: {
    FindJobsIcon,
    MyJobsIcon,
    ReferAFriendIcon,
    MyReferralsIcon,
    JobAlertIcon,
    ForumIcon,
    HelpIcon,
    InboxIcon,
    TimesheetIcon,
    SurveyIcon,
  },
})
export default class Home extends Vue {
  private ICON_MAPPER = {
    FIND_JOBS: 'FindJobsIcon',
    REFER_A_FRIEND: 'ReferAFriendIcon',
    MY_JOBS: 'MyJobsIcon',
    MY_REFERRALS: 'MyReferralsIcon',
    JOB_ALERTS: 'JobAlertIcon',
    FORUM: 'ForumIcon',
    SURVEY: 'SurveyIcon',
    TIMESHEETS: 'TimesheetIcon',
    INBOX: 'InboxIcon',
    HELP: 'HelpIcon',
  };

  private ROUTE_MAPPER = {
    FIND_JOBS: 'Findjobs',
    REFER_A_FRIEND: 'ReferAFriend',
    MY_JOBS: 'myjobstatus',
    MY_REFERRALS: 'MyReferralsList',
    JOB_ALERTS: 'JobAlertV2',
    FORUM: 'Forum',
    SURVEY: 'SurveyLanding',
    TIMESHEETS: 'Timesheet',
    INBOX: 'Inbox',
    HELP: 'Help',
  };

  goToRoute(name) {
    if (name == 'myjobstatus') {
      this.$router.push('/' + name);
    } else {
      this.$router.push({ name });
    }
  }
  get homeCards() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const home = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (option) => option.sectionKey === 'HOME',
      );
      if (!home) {
        return [];
      }
      const tabMenuOption = home.subSections.find(
        (option) => option.sectionKey === 'TAB_MENU_OPTION',
      );
      if (!tabMenuOption) {
        return [];
      }
      const homeCards = tabMenuOption.subSections.filter(
        (option) =>
          Object.keys(this.ICON_MAPPER).includes(option.sectionKey),
      );
      if(!vxm.configs.isReferralEnabled('REFERRAL_ENABLED')){
        this.lodash.remove(homeCards,{sectionKey:"REFER_A_FRIEND",});
      }
      return ( homeCards|| []).map((card) => {
        if(card.sectionKey === 'TIMESHEETS' && vxm.configs.getGlobalConfigValue('EXTERNAL_TIMESHEETS')){
          return {
            text: this.getCardDisplayName(card),
            icon: this.ICON_MAPPER[card.sectionKey],
            route: 'TargetRecruitTimesheet',
          };
        }
        return {
          text: this.getCardDisplayName(card),
          icon: this.ICON_MAPPER[card.sectionKey],
          route: this.ROUTE_MAPPER[card.sectionKey],
        };
      });
    }
    const cards = [
      {
        icon: 'FindJobsIcon',
        text: this.$t(`home.cards.find_jobs.displayName`),
        route: 'Findjobs',
      }
    ];

    if (vxm.configs.getGlobalConfigBooelanValue('REFERRAL_ENABLED')) {
      cards.push({
        icon: 'ReferAFriendIcon',
        text: this.$t(`home.cards.refer_a_friend.displayName`),
        route: 'ReferAFriend',
      });
    }
    
    cards.push({
      icon: 'MyJobsIcon',
      text: this.$t(`home.cards.my_jobs.displayName`),
      route: 'myjobstatus',
    });

    return cards;
  }

  get canShowReferFriendPopup() {
    return vxm.configs.getGlobalConfigValue('INTERNAL_REFERRAL_ENABLED');
  }

  showReferAFriendPopup() {
    this.$modal.show('refer-friend-popup');
  }

  getCardDisplayName(card: any) {
    const normalizedKey = card.sectionKey.toLowerCase();
    return this.$t(`home.cards.${normalizedKey}.displayName`);
  }
}
